import { useEffect, useState } from "react";
import styles from "./organisationDetail.module.scss";
// import ConnectCard from "src/components/connectCard/ConnectCard";
// import RecentTrans from "src/components/recentTrans/RecentTrans";
import PersonWelCard from "src/components/personWelCard/PersonWelCard";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/page/store";
import {
  getOrgDetailAction,
  // fetchTransListAction,
  addCardAction
  // orgUserListAction,
  // orgWalletListAction,
  // orgCardListAction
} from "./organisationDetailSlice";
import OrgInfoCard from "src/components/orgInfoCard/OrgInfoCard";
// import { Button } from "@mui/material";
import Modalui from "src/components/UI/modal/Modalui";
import AttachCard from "src/components/attachCard/AttachCard";
import CircularLoader from "src/components/UI/circularLoader/CircularLoader";
import { SubsList } from "../plans/plansSlice";
import PricingPlanCard from "src/components/subscriptionPlan/SubscriptionCard/PricingPlanCard";
// import { CAN_CONNECT_CARD } from "src/components/constant/constant";

interface OrganisationDetailProp {
  organisationID?: string;
  containerStyles?: string;
}

export default function OrganisationDetail({ containerStyles }: OrganisationDetailProp) {
  // const [receiptPresent, setReceiptPresent] = useState<null | boolean>(null);
  // const [isReviewed, setIsReviewed] = useState<null | boolean>(null);
  const [cardModal, setCardModal] = useState(false);
  const { organisationId } = useParams();
  const { orgDetail, organisationDetailLoading, OrgSubscription } = useAppSelector((state) => state.organisationDetail);
  // const { config } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  useEffect(() => {
    // const data = {
    //   page: 0,
    //   limit: 5,
    //   // receiptPresent,
    //   // isReviewed,
    //   organisationIds: [parseInt(organisationId!)],
    //   statuses: ["Success", "Complete", "Hold"]
    // };

    if (organisationId) {
      dispatch(getOrgDetailAction(organisationId));
      // dispatch(orgUserListAction(String(orgDetail.organisation.id)));
      // dispatch(
      //   orgWalletListAction({
      //     from: 0,
      //     size: 10,
      //     orgFilter: {
      //       organisationDisplayId: String(orgDetail.organisation.id)
      //     }
      //   })
      // );
      // dispatch(
      //   orgCardListAction({
      //     from: 0,
      //     size: 10,
      //     card_filter: {
      //       card_status: "ACTIVE"
      //     },
      //     org_filter: {
      //       organisationDisplayId: String(orgDetail.organisation.id)
      //     }
      //   })
      // );
      // fetchTransListAction(data);
    }
  }, [dispatch, orgDetail.organisation.id, organisationId]);

  const handleCardModal = () => {
    setCardModal(!cardModal);
  };

  // const walletConnectHeading = "Wallet Connect";

  const handleAddCard = (cardNumber: string, cardId: string, close: boolean, connectedToParticipant: boolean) => {
    const data = {
      cardId: Number(cardId),
      applyToAll: connectedToParticipant,
      action: "LINK"
    };

    addCardAction(data, Number(organisationId)).then(() => {
      dispatch(getOrgDetailAction(Number(organisationId)));
    });

    if (close) {
      setCardModal(false);
    }
  };

  return (
    <>
      <Modalui open={cardModal} handleClose={handleCardModal}>
        <AttachCard
          handleClose={handleCardModal}
          participantName={orgDetail.organisation.name}
          organisationId={orgDetail?.organisation?.id}
          onAddSupporter={handleAddCard}
        />
      </Modalui>
      <div className={`${styles.orgPage} ${containerStyles}`}>
        {organisationDetailLoading ? (
          <CircularLoader progressStyles={styles.circularProgress} />
        ) : (
          <>
            <div className={styles.orgPageWelCard}>
              <PersonWelCard
                img={orgDetail?.organisation?.name?.charAt(0).toLocaleUpperCase()}
                imgName={orgDetail?.organisation?.name}
                heading={orgDetail?.organisation?.name}
                subHeading1={orgDetail?.organisation?.abn}
                subHeading2={String(orgDetail?.organisation?.id)}
                connectedTo={"Org"}
              />
            </div>
            <div className={styles.orgPageHead}>
              {orgDetail && (
                <div className={styles.orgInfoSection}>
                  <OrgInfoCard org={orgDetail?.organisation} />
                </div>
              )}
              {OrgSubscription?.list?.length > 0 && (
                <div className={styles.subscriptionSection}>
                  <h5>Subscription</h5>
                  {OrgSubscription?.list?.map((subscription: SubsList) => (
                    <PricingPlanCard
                      key={subscription.subsId}
                      title={subscription.title}
                      subTitle={subscription.subTitle}
                      description={subscription.description}
                      category={subscription.subscription_category}
                      containerStyles={styles.pricingPlanContainer}
                      buttonStyles={styles.pricingPlanButtonStyle}
                      // onButtonClick={() => {
                      //   upgradePlan(subscription.subsId);
                      // }}
                      // loading={upgradePlanLoading}
                    />
                  ))}
                </div>
              )}
              {/* <ConnectCard
            walletUsers={orgDetail.wallets}
            heading={walletConnectHeading}
            connectedTo={"OrgWallet"}
            walletMemberOver={styles.walletMemberOver}
            connectCardOver={styles.walletConnectCardOver}
          >
            <Link to={`/organisation/${orgDetail?.organisation?.organisationId}/wallets`}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#1e293b",
                  height: "29px",
                  width: "76px",
                  fontSize: "12px",
                  fontWeight: "600",
                  lineHeight: "normal",
                  margin: "0",
                  padding: "0"
                }}
              >
                View All
              </Button>
            </Link>
          </ConnectCard>
          <ConnectCard
            walletUsers={orgDetail.cards}
            heading={"Card Connect"}
            connectedTo={"OrgCards"}
            walletMemberOver={styles.walletMemberOver}
            connectCardOver={styles.walletConnectCardOver}
          >
            <Link to={`/organisation/${orgDetail?.organisation?.organisationId}/cards`}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#1e293b",
                  height: "29px",
                  width: "76px",
                  fontSize: "12px",
                  fontWeight: "600",
                  lineHeight: "normal",
                  margin: "0",
                  padding: "0"
                }}
              >
                View All
              </Button>
            </Link>
          </ConnectCard> */}
            </div>
            <div className={styles.orgPageBottom}>
              <div className={styles.connectCards}>
                {/* <ConnectCard
              walletUsers={orgUser}
              heading={"User Connect"}
              connectedTo={"OrgUser"}
              walletMemberOver={styles.userMemberOver}
              connectCardOver={styles.userConnectCardOver}
            >
              <Link to={`/organisation/${orgDetail?.organisation?.organisationId}/users`}>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#1e293b",
                    height: "29px",
                    width: "76px",
                    fontSize: "12px",
                    fontWeight: "600",
                    lineHeight: "normal",
                    margin: "0",
                    padding: "0"
                  }}
                >
                  View All
                </Button>
              </Link>
            </ConnectCard> */}
                {/* <ConnectCard
              walletUsers={orgDetail?.users}
              heading={"Card Connect"}
              connectedTo={"OrgUser"}
              connectCardOver={styles.userConnectCardOver}
            >
              {config?.allowedPermissions.includes(CAN_CONNECT_CARD) && (
                <AddIcon className={styles.editIcon} onClick={handleCardModal} />
              )}
            </ConnectCard> */}
              </div>
              {/* <RecentTrans
            transList={transList?.trans}
            setReceiptPresent={setReceiptPresent}
            setIsReviewed={setIsReviewed}
            organisationId={Number(organisationId)}
            role={"OrganisationId"}
            recentTransOver={styles.recentTransOver}
            subTitle={"These are the details of the transactions made by this organisation"}
          /> */}
            </div>
          </>
        )}
      </div>
    </>
  );
}
